// extracted by mini-css-extract-plugin
export default {"tooltip":"wifiTargeting_tooltip__KU3jU","prioritized":"wifiTargeting_prioritized__4O2xR"};